import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VentasService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/ventas', httpClient, authService);
  }

  crearVentaConDetalles(ventaData: any): Observable<any> {
    return this.post(ventaData, '');
  }

}
